<template>
  <div class="ask-info-wrapper">
    <van-nav-bar title=" " left-text="订单信息" left-arrow @click-left="onClickLeft" placeholder fixed/>
    <div class="info-box">
      <div class="info-title">
        <van-icon :name="require('@/assets/images/ask/user.png')" size="3.89vw"/>
        <div class="title">基本信息</div>
      </div>
      <div class="user-info">
        <div>
          {{ getUserAskInfo().name }}
          <span style="margin:0 15px">{{ getUserAskInfo().sex }}</span>
          {{ getUserAskInfo().age }}
        </div>
        <div>
          {{ (askInfo.region || []).join(' ') }}
          <span class="vertical">|</span>
          {{ `${askInfo.maritalStatus} ${askInfo.maternityStatus}` }}
        </div>
        <div>手机号：{{ askInfo.userMemberMobile }}</div>
        <div>身份证：{{ askInfo.idCard }}</div>
        <div class="isMainland" v-if="askInfo.isMainland">非中国大陆用户</div>
      </div>
      <div class="card-box" v-if="askInfo.isMainland">
        <div class="card-title">有效证件</div>
        <div class="card-imgs" v-if="askInfo.idCardFront && askInfo.isMainland">
          <UploadImgs :fileStr="askInfo.idCardFront" :width="180" :height="128" isPreview :margin="0"/>
          <UploadImgs :fileStr="askInfo.idCardBack" :width="180" :height="128" isPreview :margin="0"/>
        </div>
      </div>
      <van-cell title="疾病史" :value="askInfo.diseaseHistory.replaceAll('|', '/')"/>
      <van-cell title="手术史或外伤史" :value="askInfo.operation.replaceAll('|', '/')"/>
      <van-cell title="家族病史" :value="askInfo.familyHistory.replaceAll('|', '/')"/>
      <van-cell title="药物过敏" :value="askInfo.drugAllergy.replaceAll('|', '/')"/>
      <van-cell title="食物/接触过敏" :value="askInfo.foodAllergy.replaceAll('|', '/')"/>
      <van-cell title="月经史" :value="askInfo.menstrualHistory.replaceAll('|', '/')" v-if="askInfo.sex === 0"/>
      <van-cell title="辅助检查史" :value="askInfo.auxiliaryExamination.replaceAll('|', '/')"/>
    </div>
    <div class="info-box">
      <div class="info-title">
        <van-icon :name="require('@/assets/images/ask/ask.png')" size="3.89vw"/>
        <div class="title">问诊信息</div>
      </div>
      <van-cell title="服药感受" class="cell-column">
        <div>{{ askInfo.takeMedicineFeel || '-' }}</div>
      </van-cell>
      <van-cell title="病情描述" class="cell-column">
        <div style="margin:5px 0;">{{ askInfo.askIllness || '-' }}</div>
        <UploadImgs class="upload-imgs-box" :fileStr="askInfo.askImages" isPreview/>
      </van-cell>
      <van-cell title="三因问卷" class="cell-column">
        <div class="three-factors">
          <div class="factors-item">
            <div class="factors-title">隆：</div>
            <div class="factors-value">{{ askInfo.factorsOne.join('、') }}</div>
          </div>
          <div class="factors-item">
            <div class="factors-title">赤巴：</div>
            <div class="factors-value">{{ askInfo.factorsTwo.join('、') }}</div>
          </div>
          <div class="factors-item">
            <div class="factors-title">培根：</div>
            <div class="factors-value">{{ askInfo.factorsThree.join('、') }}</div>
          </div>
        </div>
      </van-cell>
      <div class="van-hairline--bottom" style="height:1px;margin:9px 0;"></div>
      <van-cell title="舌诊照片" class="cell-column">
        <div class="upload-imgs">
          <div v-for="(item, index) in [
                        '左眼眼睑',
                        '右眼眼睑',
                        '舌苔',
                        '舌下脉络'
                    ]" :key="index" class="upload-item">
            <div class="upload-box">
              <UploadImgs :fileStr="askInfo.threeConditionImages[index]" :limit="1" isPreview/>
            </div>
            <div class="upload-title">
              <div>{{ item }}</div>
            </div>
          </div>
        </div>
      </van-cell>
    </div>
    <div class="info-box">
      <div class="info-title">
        <van-icon :name="require('@/assets/images/ask/doctor.png')" size="3.89vw"/>
        <div class="title">医生诊断</div>
      </div>
      <van-cell title="病种诊断" class="cell-column">
        <template v-if="askInfo.diseaseTypeList.length !== 0">
                    <span v-for="(item, index) in askInfo.diseaseTypeList" :key="index"
                          :style="{ color: index == 0 ? '#0082ef' : '', marginRight: '5px' }">
                        {{ item }}
                    </span>
        </template>
        <template v-else>病种待确认</template>
      </van-cell>
      <van-cell title="主诉症状" class="cell-column">
        <template v-if="askInfo.askDiseaseList.length !== 0">
                    <span v-for="(item, index) in askInfo.askDiseaseList" :key="index"
                          :style="{ marginRight: '5px' }">
                        {{ item.name }}
                    </span>
        </template>
        <template v-else>症状待确认</template>
      </van-cell>
      <van-cell title="用药周期"
                :value="prescriptionInfo.medicationPeriod == 5 ? `${prescriptionInfo.mpValue}天` : `${optionsName(medicationPeriod, prescriptionInfo.medicationPeriod, 'remark', 'key')}天` || '无'"
                class="cell-column"/>
      <van-cell title="临床诊断" :value="prescriptionInfo.diagnose || '无'" class="cell-column"/>
      <van-cell title="医嘱：" :value="prescriptionInfo.advice || '无'" class="cell-column"/>
      <div class="line"></div>
      <div class="prescription-box">
        <!-- <div class="prescription-title">
          <div>处方</div>
          <div class="view-prescription" @click="onViewImgs">
            查看电子处方
            <van-icon name="arrow" size="3.89vw"/>
          </div>
        </div> -->
        <div class='prescription-list'>
          <!-- <div class="prescription-item van-hairline--bottom"
               v-for="(item, idx) in prescriptionInfo.prescriptionList" :key="idx">
            <div class="prescription-top">
              <div class="prescription-name">{{ item.drugName }}</div>
              <div class="prescription-price">￥{{ Number(item.price).toFixed(2) }}</div>
            </div>
            <div class="prescription-info">
              <div class="prescription-left">用法：{{ item.dosage }}{{ item.dosageUnitName }} {{
                  item.frequencyName
                }} {{ item.drugUsageName }}
              </div>
              <div class="prescription-right">{{ askDrugPackCount(item).name }}</div>
            </div>
          </div> -->
        </div>
        <div class="price-box">
          <div class="price-item">
            <div class="price-lable">药品总金额</div>
            <div class="price-value">
              ￥{{ Number(prescriptionInfo.totalFee || 0).toFixed(2) }}
            </div>
          </div>
          <CouponSelect v-model="couponAmount" :couponId.sync="couponId" :couponName.sync="couponName"
                        :user-member-id="$route.query.userMemberId"
                        :user-no="askInfo.userNo" :total-fee="prescriptionInfo.totalFee" v-slot="{ count }">
            <div class="price-item">
              <div class="price-lable">优惠券</div>
              <div class="view-prescription price-value">
                <div v-if="couponName">{{ couponName }}</div>
                <div style="color:red;" v-else-if="count">我有可使用的优惠券</div>
                <div v-else>去兑换</div>
                <van-icon name="arrow" size="3.89vw" color="#C4C4C4"/>
              </div>
            </div>
            <div class="price-result van-hairline--bottom">
              <div class="result-name">合计：</div>
              <div>￥</div>
              <div class="big-price">{{
                  Number(prescriptionInfo.totalFee - couponAmount ||
                      0).toFixed(2).split('.')[0]
                }}
              </div>
              <div>.{{ Number(prescriptionInfo.totalFee - couponAmount || 0).toFixed(2).split('.')[1] }}</div>
            </div>
          </CouponSelect>

        </div>
        <div class="prescription-title">
          <div>问诊编号</div>
          <div class="ask-no">{{ prescriptionInfo.askNo }}</div>
          <div style="margin:0px 5px;">|</div>
          <div class="view-prescription" @click="onCopeAskNo(prescriptionInfo.askNo)">
            复制
          </div>
        </div>
        <div class="remark">如有备注、开具发票、取消订单等需要，请联系您的健康管家。</div>
      </div>
    </div>
    <!-- <div class="info-box">
      <div class="info-title">
        <div>收货地址</div>
        <div class="title edit-box" @click="onAddressEditShow">
          <van-icon :name="require('@/assets/images/ask/edit.png')" size="3.89vw"/>
          <div class="edit-title">修改地址</div>
        </div>
      </div>
      <template v-if="askInfo.userDeliveryAddress.name">
        <van-cell title="收货方式：" :value="askInfo.userDeliveryAddress.deliverType === 2 ? '自取' : '快递'"/>
        <template v-if="askInfo.userDeliveryAddress.deliverType !== 2">
          <div class='address-box'>
            <div class="left">收</div>
            <div class="right">
              <div class="right-top">
                {{ askInfo.userDeliveryAddress.name }} {{ askInfo.userDeliveryAddress.phone }}
              </div>
              <div>{{
                  `${askInfo.userDeliveryAddress.province} ${askInfo.userDeliveryAddress.city}
                                                            ${askInfo.userDeliveryAddress.area} ${askInfo.userDeliveryAddress.address}`
                }}
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <van-cell title=" " value="未填写"/>
      </template>

    </div> -->
    <div class="bottom-box safe-area-inset-bottom">
      <div class="bottom-container">
        <van-button type="primary" class="button-box" @click="onSendLink(1)">发送微信支付链接</van-button>
        <van-button type="info" class="button-box" @click="onSendLink(2)">发送支付宝链接</van-button>
      </div>
    </div>
    <address-fill :deliver-type="askInfo.userDeliveryAddress.deliverType" :defaults="askInfo.userDeliveryAddress"
                  :ask-no="askInfo.askNo" :user-no="askInfo.userNo" ref="addressFillRef" @success="onAddressSuccess"/>
    <van-dialog v-model="dialogState.show" title="支付链接码" confirmButtonColor="#1989fa">
      <div class="qr-box">
        <img :src="dialogState.url" class="qr-img-box"/>
        <div class="qr-title">请长按复制支付链接码</div>
      </div>
    </van-dialog>
    <van-dialog v-model="payQrcodeInfo.show" :title="payQrcodeInfo.title"
                confirm-button-color="#1989fa">
      <div class="pay_code_box">
        <p class="title_tips">使用{{ payQrcodeInfo.type == 1 ? '微信' : '支付宝' }}扫一扫/长按识别支付</p>
        <div class="pay_qrcode" v-if="payQrcodeInfo.url">
          <div class="qrcode_img">
            <Qrcode :content="payQrcodeInfo.url" :src.sync="payQrcodeInfo.src" :options="{ margin: 4 }"/>
          </div>
        </div>
        <p class="tips_text">请长按保存</p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import qrcode from 'qrcode'
import CouponSelect from '@/components/coupon/select.vue'
import AddressFill from '@/components/address/fill.vue'


import {ageTimeFormat, getIdCardInfo, formatteThreeConditionImages} from '@/utils/utils'
import {timeFormat} from "@/utils/baseFormat";
import {mapGetters} from 'vuex';
import {getPatientDetails, getAskDetail, getAskPrescription, getMedicationPeriod} from '@/api/index'
import {optionsName} from '@/utils/index.js'
import {askDrugPackCount} from '@/utils/utils.js'
import {getDoctorPrescriptionByaskNo} from '@/api/ask'
import {uploadOther} from "@/api/index";
import {base64ToFile} from '@/utils/utils'
import Qrcode from "@/components/qrcode/index.vue";

export default {
  name: 'viewAskInfo',
  components: {
    Qrcode,
    CouponSelect,
    AddressFill
  },
  data() {
    return {
      askInfo: {
        isMainland: false,
        name: '', //姓名
        sex: '',// 性别
        idCard: '', //身份证
        idCardFront: '',
        idCardBack: '',
        birthday: '',// 出生日期
        userMemberMobile: '',// 手机
        region: [], //城市
        maritalStatus: '其他',//婚姻
        maternityStatus: '未生育',// 生育
        diseaseHistory: '暂无', //疾病史
        operation: '暂无', //手术史或外伤史
        familyHistory: '暂无', //家族病史
        drugAllergy: '暂无', // 药物过敏
        foodAllergy: '暂无', //食物/接触过敏
        menstrualHistory: '暂无', //月经史
        auxiliaryExamination: '暂无', //辅助检查史
        askImages: '',  // 相关病情图片
        threeConditionImages: ['', '', '', ''], // 舌诊
        diseaseType: null, // 主诉
        diseaseTypeList: [], // 病种
        //三因
        questions: [],
        factorsOne: [],
        factorsTwo: [],
        factorsThree: [],
        askIllness: '',
        userDeliveryAddress: {},
        askDiseaseList: []
      },
      prescriptionInfo: {},
      medicationPeriod: [],
      couponAmount: '',
      couponId: '',
      couponName: '',
      dialogState: {
        show: false,
        url: ''
      },
      payQrcodeInfo: {
        show: false,
        title: '支付链接码',
        type: 1,  //1 微信     2支付宝
        url: '',
        src: ''
      }
    }
  },
  created() {
    this.onGetInfo()
    this.onGetPrescriptionInfo()
    this.onGeMedicationPeriod()
  },
  computed: {
    ...mapGetters({threeFactorsList: 'getThreeFactorsList', diseaseList: 'getDiseaseType'}),
    show: {
      get() {
        return this.showViewAskInfoPopup
      },
      set(value) {
        this.$emit("update:showViewAskInfoPopup", value);
      }
    }
  },
  methods: {
    optionsName,
    askDrugPackCount,
    onClickLeft() {
      this.$router.back()
    },
    getUserAskInfo() {
      // 非大陆用户
      if (this.askInfo.isMainland) {
        return {
          name: this.askInfo.name,
          sex: this.askInfo.sex === 0 ? '女'
              : this.askInfo.sex === 1
                  ? '男'
                  : '',
          age: this.askInfo.birthday
              ? ageTimeFormat(this.askInfo.birthday) + '岁'
              : ''
        }
      } else {
        return {
          name: this.askInfo.name,
          sex: getIdCardInfo(this.askInfo.idCard).sex,
          age: getIdCardInfo(this.askInfo.idCard).age + '岁'
        }
      }

    },
    async onGetInfo() {
      const {userMemberId, askNo} = this.$route.query
      try {
        const {data: healthData} = await getPatientDetails({id: userMemberId})
        const {
          userMemberHealth: {
            auxiliaryExaminatio,
            menstrualHistory,
            foodAllergy,
            drugAllergy,
            familyHistory,
            operation,
            diseaseHistory,
            maternityStatus,
            maritalStatus,
            auxiliaryExamination
          }, province, city, mobile, birthday, idCardFront, idCardBack, idCard, sex, name, isMainland
        } = healthData
        // 补方 直接带全部信息
        if (askNo) {
          const {data: askInfoData} = await getAskDetail({askNo: askNo})
          const {
            askIllness,
            images,
            threeConditionImages,
            diseaseType,
            subDiseaseTypes,
            remark,
            userThreeConditionQuestionList,
            takeMedicineFeel,
            askDiseaseList
          } = askInfoData
          let feedbackData = {
                feedback0: [],
                feedback1: [],
                feedback2: []
              }
          ;(userThreeConditionQuestionList || []).forEach((item) => {
            this.threeFactorsList.forEach((Item) => {
              if (
                  item.questionType === Item.questionType &&
                  item.questionKewWord === Item.questionKewWord
              )
                feedbackData[`feedback${item.questionType}`].push(
                    Item.questionSubject
                )
            })
          })

          const subDiseaseTypeList = [];
          [...new Set([String(diseaseType), ...(subDiseaseTypes || '').split(',')])].forEach(item => {
            this.diseaseList.forEach(Item => {
              if (item == Item.key) {
                subDiseaseTypeList.push(Item.value)
              }
            })
          })
          this.askInfo = {
            ...askInfoData,
            askIllness: askIllness,
            takeMedicineFeel: takeMedicineFeel,
            askImages: images || '',
            threeConditionImages: formatteThreeConditionImages(threeConditionImages),
            diseaseType: diseaseType, // 主诉
            diseaseTypeList: subDiseaseTypeList, // 病种,
            remark,
            factorsOne:
                feedbackData.feedback0.length === 0
                    ? ['暂无以上症状']
                    : feedbackData.feedback0,
            factorsTwo:
                feedbackData.feedback1.length === 0
                    ? ['暂无以上症状']
                    : feedbackData.feedback1,
            factorsThree:
                feedbackData.feedback2.length === 0
                    ? ['暂无以上症状']
                    : feedbackData.feedback2,
            auxiliaryExaminatio: auxiliaryExaminatio || '暂无',
            menstrualHistory: menstrualHistory || '暂无',
            foodAllergy: foodAllergy || '暂无',
            drugAllergy: drugAllergy || '暂无',
            familyHistory: familyHistory || '暂无',
            operation: operation || '暂无',
            diseaseHistory: diseaseHistory || '暂无',
            maternityStatus: maternityStatus || '未生育',
            maritalStatus: maritalStatus || '未生育',
            auxiliaryExamination: auxiliaryExamination || '暂无',
            region: [province, city].filter(item => !!item),
            userMemberMobile: mobile,
            birthday: timeFormat(birthday, "yyyy-mm-dd"),
            idCardBack: idCardBack,
            idCardFront: idCardFront,
            idCard: idCard,
            sex: sex,
            name: name,
            isMainland: isMainland === 0,
            askDiseaseList
          }

        }
      } catch (error) {
        console.log(error)
      }
    },
    async onGetPrescriptionInfo() {
      try {
        const {data: prescriptionInfo} = await getAskPrescription({askNo: this.$route.query.askNo})
        this.prescriptionInfo = prescriptionInfo
      } catch (error) {
        console.log(error)
        this.prescriptionInfo = {}
      }
    },
    async onGeMedicationPeriod() {
      try {
        const {data} = await getMedicationPeriod()
        this.medicationPeriod = data.list;
      } catch (error) {
        this.medicationPeriod = [];
        console.log(error)
      }
    },
    onAddressEditShow() {
      this.$refs.addressFillRef && this.$refs.addressFillRef.onAddressGet().then(() => {
        this.$refs.addressFillRef.onAddressShow();
      });
    },
    onAddressSuccess() {
      this.onGetInfo()
    },
    onCopeAskNo(value) {
      const input = document.createElement('input')
      input.value = value
      document.body.appendChild(input)
      input.select()
      document.execCommand('Copy')
      document.body.removeChild(input)
      this.$toast('复制成功');
    },
    async onViewImgs() {
      const {data} = await getDoctorPrescriptionByaskNo({
        askNo: this.askInfo.askNo,
        statusArry: '1,2,6,7',
        pageNo: 1,
        pageSize: 50
      })
      let imgs = data.list.map(item => process.env.VUE_APP_IMG_HOST + item.url).reverse()
      this.$viewerApi({
        images: imgs,
        options: {
          title: false,
        },
      });
    },
    onSendLink(type) {
      if (type === 1) {
        try {
          var opts = {
            errorCorrectionLevel: 'H',
            type: 'image/jpeg',
            quality: 0.3,
            margin: 1,
            color: {
              light: "#fff"
            }
          }
          const url = `${process.env.VUE_APP_AUTHORIZE_CONSENT}?type=ask&askNo=${this.$route.query.askNo}`
          qrcode.toDataURL(url, opts, async (err, base64Url) => {
            if (err) throw err
            // base 64 转file
            const formData = new FormData();
            formData.append("file", base64ToFile(base64Url, '二维码.jpeg'));
            formData.append("module", "efficacy");
            formData.append("category", "track");
            formData.append('async', 'false') // 正式环境 接口返回慢了
            const {data} = await uploadOther(formData)
            this.dialogState = {
              show: true,
              url: data.absoluteUrl
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
      if (type === 2) {
        this.payQrcodeInfo.type = type
        this.payQrcodeInfo.url = `${window.location.origin}#/medicationPayment?payType=1&askNo=${this.$route.query.askNo}&couponId=${this.couponId}&couponPrice=${this.couponAmount || 0}&alipay=alipay`
        // WZ2024080805694
        this.payQrcodeInfo.show = true

      }

    },
  },
}
</script>
<style lang="scss" scoped>
.qr-box {
  padding: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;

  .qr-title {
    margin-top: 20px;
    font-size: 16px;
  }

  .qr-img-box {
    width: 150px;
    height: 150px;
  }
}

#QR {
  display: none;
}

.ask-info-wrapper {
  padding: 18px;
  padding-bottom: 100px;
  background: #F6F6F6;
  font-size: 16px;

  .info-box {
    overflow: hidden;
    background: #fff;
    box-shadow: 0px 0px 37px 0px rgba(204, 204, 204, 0.1);
    border-radius: 15px;
    padding: 0 16px 9px;

    + .info-box {
      margin-top: 18px;
    }

    .info-title {
      font-size: 18px;
      color: #333;
      font-weight: bold;
      display: flex;
      align-items: center;
      padding: 18px 0;

      .title {
        margin-left: 12px;
      }

      .edit-box {
        display: flex;
        margin-left: auto;
        align-items: center;
        color: #0082EF;
        font-weight: normal;
        font-size: 16px;
        cursor: pointer;

        .edit-title {
          margin-left: 2px;
        }
      }
    }

    .user-info {
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #E1E8EF;
      padding: 10px 15px;
      position: relative;

      div {
        color: #666666;
        margin-top: 6px;

        &:nth-child(1) {
          font-size: 18px;
          color: #333;
          font-weight: bold;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      }

      .vertical {
        color: #0082EF;
        margin: 0 8px;
      }

      .isMainland {
        position: absolute;
        right: 0;
        top: 0;
        background: #0082ef;
        border-radius: 0px 10px 0px 10px;
        font-size: 12px;
        padding: 2px 4px;
        color: #fff;
        margin: 0;
      }
    }

    .card-box {
      padding: 18px 0 9px;

      .card-title {
        margin-bottom: 18px;
      }

      :deep(.card-imgs) {
        overflow: hidden;
        display: flex;
        justify-content: space-between;

      }
    }

    :deep(.upload-imgs-box) {
      padding-top: 5px;
    }

    .three-factors {
      .factors-item {
        margin-top: 12px;
        display: flex;

        .factors-title {
          color: #333;
          font-weight: bold;
        }

        .factors-value {
          flex: 1
        }
      }
    }

    .upload-imgs {
      padding-top: 12px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .upload-item {
        overflow: hidden;
        width: 91px;

        .upload-title {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #777;
          margin-top: 9px;
        }

        .upload-box {
          height: 91px;
          border-radius: 10px;
          overflow: hidden;
        }
      }
    }

    .line {
      width: 200%;
      height: 1px;
      margin: 10px 0;
      margin-left: -20%;
      background: #F6F6F6;
    }
  }


}


.bottom-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 0px 0px 0px 0px;
  z-index: 10;
  background: #ffffff;

  .bottom-container {
    height: 84px;
    background: #ffffff;
    box-sizing: border-box;
    padding: 16px 25px;
    display: flex;
    justify-content: center;

    .button-box {
      font-size: 18px;
      border: none;
      border-radius: 8px;
    }
    .button-box:last-child{
      margin-left: 10px;
    }
  }
}

:deep(.van-nav-bar) {

  .van-nav-bar__left,
  .van-icon {
    font-size: 20px;
  }
}

:deep(.van-cell):not(.van-field) {
  padding: 9px 0;
  line-height: normal;

  &::after {
    display: none;
  }

  .van-cell__title {
    color: #666;
    flex-shrink: 0;
    min-width: 30vw;
    margin-right: 20px;
  }

  .van-cell__value {
    text-align: left;
    flex: 0 1 auto;
    color: #333;
    padding: 5px 0;
  }

}

:deep(.cell-column) {
  flex-direction: column;
}

.prescription-box {

  .prescription-title {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #777777;

    .view-prescription {
      color: #0082ef;
      cursor: pointer;
    }

    .ask-no {
      margin-left: auto;
      color: #333333;
    }
  }

  .prescription-list {
    .prescription-item {
      padding: 15px 0;
      color: #333333;

      .prescription-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .prescription-name {
          font-size: 16px;
          font-weight: bold;
        }
      }

      .prescription-info {
        margin-top: 4px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .prescription-left {
          flex: 1;
          margin-right: 10px;
        }

        .prescription-right {
          color: #666666;
        }
      }

    }
  }

  .price-box {
    padding: 14px 0;
    font-size: 16px;

    .price-item {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;

      .price-lable {
        color: #666666;
      }

      .price-value {
        color: #333;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
    }

    .price-result {
      font-weight: bold;
      padding: 17px 0;
      display: flex;
      justify-content: flex-end;
      color: #1989fa;
      align-items: baseline;

      .result-name {
        color: #333;
      }

      .big-price {
        font-size: 27px;
      }
    }
  }

  .remark {
    color: #999999;
    font-size: 13px;
    padding: 8px 0;
  }


}

.address-box {
  display: flex;
  align-items: center;
  padding: 10px 0;

  .left {
    width: 37px;
    height: 37px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #0082EF;
    border-radius: 50%;
    font-size: 16px;
    color: #FFFFFF;
    flex-shrink: 0;
  }

  .right {
    color: #333333;
    margin-left: 15px;

    .right-top {
      padding-bottom: 6px;
    }
  }

}

.pay_code_box {
  .title_tips {
    font-size: 14px;
    color: #aeabab;
    text-align: center;
  }

  .pay_qrcode {

    .qrcode_img {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      padding: 8px;
    }

  }

  .tips_text {
    font-size: 14px;
    color: #aeabab;
    text-align: center;
  }
}
</style>